(() => {
  function formatter(root) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency', currency: root.dataset.currency || 'CAD', currencyDisplay: 'code'
    });
  }

  function revealSelected(input) {
    const item = input.closest('.swatch-item');
    const list = item?.closest('.product-card__swatch-list');
    if (!item?.offsetWidth || !list) return;
    if (item.offsetLeft < list.scrollLeft) list.scrollLeft = item.offsetLeft;
    else if (item.offsetLeft + item.offsetWidth > list.scrollLeft + list.clientWidth) {
      list.scrollLeft = item.offsetLeft + item.offsetWidth - list.clientWidth;
    }
  }

  function initNotebooks(root) {
    const section = root.querySelector('[data-notebook-section]');
    if (!section || section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const cards = [...section.querySelectorAll('[data-notebook-card]')];
    const bundleCards = [...section.querySelectorAll('[data-bundle-card][data-bundle-kind="notebook"]')];
    const coverGroups = [...section.querySelectorAll('[data-notebook-cover-group]')];
    const preferred = new Map(cards.map(card => [card, card.querySelector('[data-notebook-variant]:checked')?.value]));
    const size = section.querySelector('[data-notebook-size]');
    const layout = section.querySelector('[data-notebook-layout]');
    const money = formatter(root);
    const isUnitedStates = root.dataset.country === 'US';

    function update(card) {
      const variant = card.querySelector('[data-notebook-variant]:checked');
      if (!variant) return;
      const url = new URL(card.dataset.productUrl, location.origin);
      url.searchParams.set('variant', variant.value);
      card.querySelectorAll('[data-notebook-product-link], [data-notebook-product-link-wrap] a').forEach(link => { link.href = url.href; });
      const quickAdd = card.querySelector('[data-notebook-quick-add-variant]');
      if (quickAdd) quickAdd.value = variant.value;
      const img = card.querySelector('.thankful20__photo img');
      if (img && img.getAttribute('src') !== variant.dataset.image) {
        img.removeAttribute('srcset');
        img.src = variant.dataset.image;
        img.alt = variant.dataset.alt || variant.dataset.variantTitle;
      }
      card.querySelector('[data-notebook-selected-variant]').textContent = variant.dataset.variantTitle;
      card.querySelector('[data-notebook-current-price]').textContent = money.format(Number(isUnitedStates ? variant.dataset.t20SalePrice : variant.dataset.t20UnitPrice) / 100);
      const regular = card.querySelector('[data-notebook-regular-price]');
      if (regular) regular.textContent = money.format(Number(variant.dataset.t20UnitPrice) / 100);
      revealSelected(variant);
    }

    function filter() {
      let count = 0;
      // Reveal groups before measuring swatch positions; hide empty groups below.
      coverGroups.forEach(group => { group.hidden = false; });
      cards.forEach(card => {
        const variants = [...card.querySelectorAll('[data-notebook-variant]')];
        const matches = variants.filter(variant => !size.value || variant.dataset.size === size.value);
        const selected = matches.find(variant => variant.value === preferred.get(card)) || matches[0];
        card.hidden = !selected || Boolean(layout.value && card.dataset.layout !== layout.value);
        card.querySelector('.product-card__swatch-list').toggleAttribute('data-swatch-filtered', Boolean(size.value));
        const more = card.querySelector('[data-notebook-show-more]');
        if (more) more.hidden = Boolean(size.value);
        variants.forEach(variant => { variant.closest('[data-notebook-variant-item]').hidden = Boolean(size.value && variant.dataset.size !== size.value); });
        if (!card.hidden) {
          selected.checked = true;
          update(card);
          count++;
        }
      });
      bundleCards.forEach(card => {
        card.hidden = Boolean((size.value && card.dataset.size !== size.value) || (layout.value && card.dataset.layout !== layout.value));
        if (!card.hidden) count++;
      });
      coverGroups.forEach(group => {
        const visible = [...group.querySelectorAll('[data-notebook-card], [data-bundle-card]')].filter(card => !card.hidden).length;
        group.hidden = visible === 0;
        group.querySelector('[data-cover-group-count]').textContent = `${visible} listing${visible === 1 ? '' : 's'}`;
      });
      section.querySelector('[data-notebook-count]').textContent = `${count} notebook listings · in-stock colours and sizes only`;
      section.querySelector('[data-notebook-empty]').hidden = count !== 0;
    }

    cards.forEach(card => card.addEventListener('change', event => {
      if (!event.target.matches('[data-notebook-variant]') || !event.target.checked) return;
      preferred.set(card, event.target.value);
      update(card);
    }));
    size.addEventListener('change', filter);
    layout.addEventListener('change', filter);
    section.querySelector('[data-notebook-filters]').hidden = false;
    filter();
  }

  function initBundleCards(root) {
    const money = formatter(root);
    const isUnitedStates = root.dataset.country === 'US';
    root.querySelectorAll('[data-bundle-card]').forEach(card => {
      const prefix = card.dataset.priceVaries === 'true' ? 'From ' : '';
      card.querySelector('[data-bundle-card-price]').textContent = prefix + money.format(Number(isUnitedStates ? card.dataset.salePrice : card.dataset.unitPrice) / 100);
      const regular = card.querySelector('[data-bundle-card-regular-price]');
      if (regular) regular.textContent = money.format(Number(card.dataset.unitPrice) / 100);
    });
  }

  function init(root) {
    initNotebooks(root);
    initBundleCards(root);
  }
  document.querySelectorAll('[data-thankful20]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-thankful20]').forEach(init));
})();
